/* eslint-disable @typescript-eslint/no-explicit-any */
import { format } from 'utils/format';
import warning from 'warning';

/*** @deprecated deprecated in favor of rm(key: string, ...args: FormatArgs[]): string */
export type Rm = (key: string, ...args: any[]) => string;

/*** @deprecated deprecated in favor of rm(key: string, ...args: FormatArgs[]): string */
export function resource(_: unknown, key: string, ...args: any[]): string {
  return rm(key, ...args);
}

export type Translations = { [key: string]: string };
let translations: Translations = {};
export function rm(key: string, ...args: any[]): string {
  const lowerCasedKey = key.toLowerCase();

  const value = translations[key] || translations[lowerCasedKey];
  if (!value) {
    warning(!value, `translation not found: ${key}`);
    return key;
  }

  const hasArgs = !args || args.length === 0;
  return hasArgs ? value : format(value, ...args);
}

export default (resource: Translations | undefined) => {
  warning(typeof resource !== 'undefined', 'Resource object is empty!');
  translations = typeof resource !== 'undefined' ? resource : {};
};
